// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCApiGatewayControllersModelsRequestTypesGetProgramRequest {
    'promotionId'?: number;
    'programCode'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCApiGatewayControllersModelsRequestTypesGetProgramRequest>> = [
        {
            "name":     "promotionId",
            "baseName": "promotionId",
            "type":     "number"
        },
        {
            "name":     "programCode",
            "baseName": "programCode",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TCApiGatewayControllersModelsRequestTypesGetProgramRequest.attributeTypeMap;
    }
}
